import { clsx } from "clsx";
import { type ReactNode } from "react";

interface Props {
  children: ReactNode;
  alertStyle?: "success" | "danger";
}

export default function Alert({ children, alertStyle = "success" }: Props) {
  const className = clsx("relative mb-4 rounded-md border border-solid p-4", {
    "border-emerald-200 bg-emerald-100 text-green-950":
      alertStyle === "success",
    "border-rose-300 bg-red-100 text-rose-950": alertStyle === "danger",
  });
  return (
    <div role="alert" className={className}>
      {children}
    </div>
  );
}
